import { InfoOutlined } from '@material-ui/icons';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { Field, reduxForm, change, FieldArray } from 'redux-form';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import CustomField from '../Fields/CustomField.jsx';
import MDCheckBoxField from '../Fields/MDCheckBox/MDCheckBoxField.js';
import TimezoneIconCustom from '../../CustomIcons/TimezoneIconCustom.jsx';
import momentTz from 'moment-timezone';
import SelectableField from '../Fields/SelectableInput/SelectableField.jsx';
import MDSwitchView from '../Fields/MDSwitch/MDSwitchView.jsx';
import { GREEN, RED } from '../../../_config/consts.js';
import { connect } from 'react-redux';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import AddIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import { Card, Divider } from '@material-ui/core';

const validate = values => {
  const errors = {};

  if (!values.pin && !values.credentialRule && !values.invitation) {
    errors.pin = 'required';
    errors.credentialRule = 'required';
    errors.invitation = 'required';
  }
  
  if (((values.sendPinToDuve && values.pin) || (values.sendInvitationToDuve && values.invitation)) && (!values.duveconnectPid || !values.duveconnectToken)) {
    errors.duveconnectPid = 'required';
    errors.duveconnectToken = 'required';
  }

  if (values.invitation && values.sendInvitationToDuve && !values.duveInvitationUrlField) {
    errors.duveInvitationUrlField = 'required';
  }
  
  if (!values.statuses || !values.statuses.length || !values.statuses[0]) {
    errors.statuses = { _error: 'required' };
  }
  
  return errors;
};

@reduxForm({ form: 'DuveActivationForm', validate })
@connect(state => ({ form: state.form.DuveActivationForm }))
export default class DuveActivationForm extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isPasswordVisible: false,
      timezones: momentTz.tz.names(),
      guessedTimezone: momentTz.tz.guess(),
      showTimezoneSelector: false,
      sendPinToDuve: false,
      sendInvitationToDuve: false,
      showReservationRoomsSwitch: false,
    };
  }

  componentDidMount() {
    const { guessedTimezone } = this.state;
    const { dispatch } = this.props;
    dispatch(change('DuveActivationForm', 'timezone', guessedTimezone));
    dispatch(change('DuveActivationForm', 'statuses', ['']));
    dispatch(change('DuveActivationForm', 'rooms', ['']));
  }

  onFilterTimezones(value) {
    const timezones = momentTz.tz.names().filter(timezone => timezone.toLowerCase().includes(value.toLowerCase()));
    this.setState({ timezones });
  }

  onSelectTimezone(selectedOption) {
    const { dispatch } = this.props;
    const selectedTimezone = selectedOption && selectedOption.value ? selectedOption.value : momentTz.tz.guess();
    dispatch(change('DuveActivationForm', 'timezone', selectedTimezone));
    this.setState({ guessedTimezone: selectedTimezone });
  }
  
  renderStatusFields = ({ fields, meta: { error, submitFailed } }) => (
    <div style={{ paddingLeft: 10, paddingRight: 10 }}>
      {fields.map((status, index) => (
        <div key={index} style={{ marginBottom: 10 }}>
          {index > 0 && <Divider style={{ marginBottom: 10 }} />}
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Entity
              id={`statuses[${index}]`}
              name={`statuses[${index}]`}
              componentClass={Field}
              componentAttribute="placeholder"
              entity="enterReservationStatus"
              title={null}
              component={CustomField}
            />
            <IconButton
              style={{ marginLeft: 10 }}
              onClick={() => fields.length > 1 && fields.remove(index)}
              disabled={fields.length <= 1}
            >
              <DeleteIcon style={{ color: fields.length > 1 ? RED : '#ccc', fontSize: 20 }} />
            </IconButton>
          </div>
        </div>
      ))}
      <Card
        style={{ height: 50, marginTop: 15, marginBottom: 10, padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center',cursor: 'pointer' }}
        className="card card-rounded"
        onClick={() => fields.push('')}
      >
        <AddIcon style={{ color: GREEN, marginRight: 15, fontSize: 22 }} />
        <h4 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="addNewStatus" /></h4>
      </Card>
      
      {submitFailed && error && (
        <div style={{ marginTop: 10, color: RED }}>
          <Entity entity={error} />
        </div>
      )}
    </div>
  );

  renderRoomsFields = ({ fields, meta: { error, submitFailed } }) => (
    <div style={{ paddingLeft: 10, paddingRight: 10 }}>
      {fields.map((room, index) => (
        <div key={index} style={{ marginBottom: 10 }}>
          {index > 0 && <Divider style={{ marginBottom: 10 }} />}
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Entity
              id={`rooms[${index}]`}
              name={`rooms[${index}]`}
              componentClass={Field}
              componentAttribute="placeholder"
              entity="enterReservationRoom"
              title={null}
              component={CustomField}
            />
            <IconButton
              style={{ marginLeft: 10 }}
              onClick={() => fields.length > 1 && fields.remove(index)}
              disabled={fields.length <= 1}
            >
              <DeleteIcon style={{ color: fields.length > 1 ? RED : '#ccc', fontSize: 20 }} />
            </IconButton>
          </div>
        </div>
      ))}
      <Card
        style={{ height: 50, marginTop: 15, marginBottom: 10, padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center',cursor: 'pointer' }}
        className="card card-rounded"
        onClick={() => fields.push('')}
      >
        <AddIcon style={{ color: GREEN, marginRight: 15, fontSize: 22 }} />
        <h4 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="addNewRoom" /></h4>
      </Card>
      
      {submitFailed && error && (
        <div style={{ marginTop: 10, color: RED }}>
          <Entity entity={error} />
        </div>
      )}
    </div>
  );

  render() {
    const { form, dispatch } = this.props;
    const { guessedTimezone, showTimezoneSelector, showReservationRoomsSwitch, timezones, sendPinToDuve, sendInvitationToDuve } = this.state;

    const isPINactive = form && form.values && form.values.pin;
    const isInvitationActive = form && form.values && form.values.invitation;

    return (
      <div style={{ marginTop: 10 }}>
        <FormFlatContainer
          title="intergrationConnectionParameters"
          titleStyle={{ marginLeft: 0 }}
        >
          <div style={{ marginTop: 20 }}>
            <Entity
              name="duveconnectPid"
              componentClass={Field}
              componentAttribute="placeholder"
              entity="duveInsertPID"
              title="DuveConnect PID"
              component={CustomField}
            />
            <Entity
              name="duveconnectToken"
              componentClass={Field}
              componentAttribute="placeholder"
              entity="duveInsertAccessToken"
              title="DuveConnect Access Token"
              component={CustomField}
            />
            </div>
        </FormFlatContainer>
        <FormFlatContainer
          title="integrationCredentialsOptions"
          titleStyle={{ marginLeft: 0 }}
        >
          <Field
            name="invitation"
            label={<Entity entity="synchronizeReservationsAsInvitationsTitle" style={{color:'#3f3f3f'}} />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 10, marginTop: -10, color:'#3f3f3f' }}><Entity entity="synchronizeReservationsAsInvitations" /></h5>
          <Field
            name="credentialRule"
            label={<Entity entity="synchronizeReservationsAsCredentialRulesTitle" style={{color:'#3f3f3f'}} />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 10, marginTop: -10, color:'#3f3f3f' }}><Entity entity="synchronizeReservationsAsCredentialRules" /></h5>
          <Field
            name="pin"
            label={<Entity entity="synchronizeReservationsAsPinsTitle" style={{ color:'#3f3f3f' }} />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 20, marginTop: -10, color:'#3f3f3f' }}><Entity entity="synchronizeReservationsAsPins" /></h5>
          {isPINactive ? (
            <div style={{ marginTop: 30 }}>
              <h4 style={{ fontWeight: 'bold', fontSize: 16, marginTop: 10 }}><Entity entity="duveSendBackPinTitle" /></h4>
              <MDSwitchView
                label={<Entity key={sendPinToDuve} entity="duveSendBackPinSubtitle" />}
                checked={sendPinToDuve}
                titleStyle={{ fontWeight: sendPinToDuve ? 'bold' : 'normal', color: sendPinToDuve ? GREEN : '#3f3f3f' }}
                onSelect={selected => {
                  this.setState({ sendPinToDuve: selected })
                  dispatch(change('DuveActivationForm', 'sendPinToDuve', selected));
                  if (!selected) {
                    dispatch(change('DuveActivationForm', 'duveconnectPid', undefined));
                    dispatch(change('DuveActivationForm', 'duveconnectToken', undefined));
                  }
                }}
              />
            </div>
          ) : null}
          {isInvitationActive ? (
            <div style={{ marginTop: 30 }}>
              <h4 style={{ fontWeight: 'bold', fontSize: 16, marginTop: 10 }}><Entity entity="duveSendBackInvitationTitle" /></h4>
              <MDSwitchView
                label={<Entity key={sendInvitationToDuve} entity="duveSendBackInvitationSubtitle" />}
                checked={sendInvitationToDuve}
                titleStyle={{ fontWeight: sendInvitationToDuve ? 'bold' : 'normal', color: sendInvitationToDuve ? GREEN : '#3f3f3f' }}
                onSelect={selected => {
                  this.setState({ sendInvitationToDuve: selected })
                  dispatch(change('DuveActivationForm', 'sendInvitationToDuve', selected));
                }}
              />
              {sendInvitationToDuve ? (
                <Entity
                  name="duveInvitationUrlField"
                  componentClass={Field}
                  componentAttribute="placeholder"
                  entity="duveInsertCustomField"
                  title={<Entity entity="duveCustomFieldId" />}
                  component={CustomField}
                  containerStyle={{ marginTop: 10 }}
                />
              ) : null}
            </div>
          ) : null}
        </FormFlatContainer>
        <FormFlatContainer
          title="integrationSettingsParameters"
          titleStyle={{ marginLeft: 0 }}
        >
          <div style={{ marginTop: 30 }}>
            {guessedTimezone ? (
              <div>
                <h4 style={{ fontWeight: 'bold', fontSize: 16, marginTop: 20 }}><Entity entity="buildingTimeZone" /></h4>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 10, paddingLeft: 15, borderRadius: 10, background: '#f0f0f0'}}>
                  <TimezoneIconCustom style={{ width: 20, marginRight: 10 }} />
                  <h5 style={{ fontWeight: 'bold', fontSize: 16 }}>{guessedTimezone}</h5>
                </div>
                <MDSwitchView
                  label={<Entity key={showTimezoneSelector} entity="notYourTimeZone" />}
                  checked={showTimezoneSelector}
                  titleStyle={{ fontWeight: showTimezoneSelector ? 'bold' : 'normal', color: showTimezoneSelector ? GREEN : '#3f3f3f' }}
                  onSelect={selected => this.setState({ showTimezoneSelector: selected })}
                />
              </div>
            ) : null}
            {showTimezoneSelector ? (
              <Field
                name="timezone"
                title={<Entity entity="selectTimezone" />}
                component={SelectableField}
                options={_.map(timezones, timezone => ({ value: timezone, label: timezone }))}
                titleStyle={{ fontSize: 16 }}
                placeholder={<Entity entity="search" />}
                containerstyle={{ widht: '100%', marginBottom: 20 }}
                onInputChange={value => this.onFilterTimezones(value)}
                onSelect={value => this.onSelectTimezone(value)}
              />
            ) : null}
          </div>
          <Divider style={{ marginTop: 20 }} />
          <div style={{ marginTop: 20 }}>
            <h4 style={{ color:'#3f3f3f', fontSize: 16, fontWeight: 'bold' }}><Entity entity="reservationStatuses" /></h4>
            <h4 style={{ marginBottom: 20, color:'#3f3f3f', fontSize: 16 }}><Entity entity="synchronizeReservationStatuses" /></h4>
            <p style={{ marginBottom: 15, color: '#3f3f3f' }}><Entity entity="synchronizeReservationStatusesSubtitle" /></p>
            <FieldArray name="statuses" component={this.renderStatusFields} />
          </div>
          <Divider style={{ marginTop: 20 }} />
          <div style={{ marginTop: 20 }}>
            <h4 style={{ color:'#3f3f3f', fontSize: 16, fontWeight: 'bold' }}><Entity entity="synchronizeUserWithoutEmailTitle" /></h4>
            <h4 style={{ marginBottom: 20, color:'#3f3f3f', fontSize: 16 }}><Entity entity="synchronizeUserWithoutEmailDescription" /></h4>
            <MDSwitchView
              label={<Entity entity="synchronizeUserWithoutEmail" />}
              checked={form && form.values && form.values.dontSendUserActivationEmail}
              titleStyle={{ 
                fontWeight: (form && form.values && form.values.dontSendUserActivationEmail) ? 'bold' : 'normal', 
                color: (form && form.values && form.values.dontSendUserActivationEmail) ? GREEN : '#3f3f3f' 
              }}
              containerStyle={{ marginTop: -10, marginBottom: 0 }}
              onSelect={selected => {
                dispatch(change('DuveActivationForm', 'dontSendUserActivationEmail', selected));
              }}
            />
          </div>
          <Divider style={{ marginTop: 20 }} />
          <div style={{ marginTop: 20 }}>
            <h4 style={{ color:'#3f3f3f', fontSize: 16, fontWeight: 'bold' }}><Entity entity="deleteUsersWithoutCredentials" /></h4>
            <h4 style={{ marginBottom: 20, color:'#3f3f3f', fontSize: 16 }}><Entity entity="deleteUsersWithoutCredentialsDescription" /></h4>
            <MDSwitchView
              label={<Entity entity="deleteUsersWithoutCredentials" />}
              checked={form && form.values && form.values.deleteUsersWithoutCredentials}
              titleStyle={{ 
                fontWeight: (form && form.values && form.values.deleteUsersWithoutCredentials) ? 'bold' : 'normal', 
                color: (form && form.values && form.values.deleteUsersWithoutCredentials) ? GREEN : '#3f3f3f' 
              }}
              containerStyle={{ marginTop: -10, marginBottom: 0 }}
              onSelect={selected => {
                dispatch(change('DuveActivationForm', 'deleteUsersWithoutCredentials', selected));
              }}
            />
          </div>
          <Divider style={{ marginTop: 20 }} />
          <div style={{ marginTop: 20 }}>
            <h4 style={{ color:'#3f3f3f', fontSize: 16, fontWeight: 'bold' }}><Entity entity="resourcesExternalIds" /></h4>
            <h4 style={{ marginBottom: 20, color:'#3f3f3f', fontSize: 16 }}><Entity entity="synchronizeReservationRooms" /></h4>
            <MDSwitchView
              label={<Entity key={showReservationRoomsSwitch} entity="synchronizeReservationRoomsSwitch" />}
              checked={showReservationRoomsSwitch}
              containerStyle={{ marginTop: -10, marginBottom: 0 }}
              titleStyle={{ fontWeight: showReservationRoomsSwitch ? 'bold' : 'normal', color: showReservationRoomsSwitch ? GREEN : '#3f3f3f' }}
              onSelect={selected => {
                this.setState({ showReservationRoomsSwitch: selected })
                if (!selected) {
                  dispatch(change('DuveActivationForm', 'rooms', ['']));
                }
              }}
            />
            {showReservationRoomsSwitch ? (
              <>
                <h4 style={{ marginBottom: 20, color:'#3f3f3f', fontSize: 16 }}><Entity entity="synchronizeReservationRoomsDetail" /></h4>
                <p style={{ marginBottom: 15, color: '#3f3f3f' }}><Entity entity="synchronizeReservationRoomsSubtitle" /></p>
                <FieldArray name="rooms" component={this.renderRoomsFields} />
              </>
            ) : (null)}
          </div>
        </FormFlatContainer>
      </div>
    );
  }
}
